import {NgModule, Component, Input, NgZone, ChangeDetectorRef} from "@angular/core";

import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {PipelineService} from "../services/pipeline/pipeline.service";
import {RaVersion} from "../services/configuration/ra.version";
import {ContentCursor} from "../services/content/content.cursor";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: "pipeline",
    templateUrl: "./pipeline.component.html",
    styleUrls: [ "./pipeline.component.scss"]
})
export class PipelineComponent extends ComponentBase {

    constructor (
        private http:HttpClient,
        private eventBus: EventBus,
        private modalConfig: ModalConfig,
        private logService: BugsnagLoggingService,
        private _ngZone: NgZone,
        private pipelineService:PipelineService,
        private contentCursor:ContentCursor,
        private ref: ChangeDetectorRef
    ) {
        super("PipelineComponent");
    }
}
